module.exports = __webpack_public_path__ + "static/media/Sec-1_2677HomePlayer.2b241186.jpg";